<h3
  class="betted-chips"
  [class.opacity-100]="show"
  [class.opacity-0]="!show"
  [class.loss]="!useEarnClass"
  [class.earned]="useEarnClass"
>
  {{ useEarnClass ? '+' : '-' }}
  {{ chips | number: '0.0-2' }} chips
</h3>
